<template>
  <div>
    <div class="lib__display__desktop__only">
      <Feedback icon simple level="success" v-if="showVatSixPercentMessage">
        <p class="lib__text-left">{{ $t('vatInfo.vatRateSixPercent') }}</p>
      </Feedback>

      <Feedback icon simple level="success" v-else-if="showVatLess10YearsMessage">
        <p class="lib__text-left">{{ $t('vatInfo.vatRateLess10Years') }}</p>
      </Feedback>

      <Feedback icon simple level="success" v-else-if="showNeedExemptionFormMessage">
        <p>{{ $t('vatInfo.needExemptionFormMessageDescription') }}</p>
      </Feedback>

      <Feedback icon level="success" v-else-if="showBasicMessage">
        <h3>{{ $t('vatInfo.basicMessage') }}</h3>
        <p>{{ $t('vatInfo.basicMessageDescription') }}</p>
      </Feedback>
    </div>

    <div class="lib__display__mobile__only vat-feedback mobile">
      <div v-if="showVatSixPercentMessage">
        <div class="lib__text-center">
          <i class="lib__icon__check__circle--success lib__icon__check__circle--big fas fa-check-circle"></i>
        </div>
        <p class="lib__text-center ">
          <span class="lib__h2 lib__btn--full">{{ $t('vatInfo.vatRateSixPercent') }}</span>
        </p>
        <p class="lib__text-center">{{ $t('vatInfo.vatRateSixPercentDescription') }}</p>
      </div>
      <div v-else-if="showVatLess10YearsMessage">
        <div class="lib__text-center">
          <i class="lib__icon__check__circle--success lib__icon__check__circle--big fas fa-check-circle"></i>
        </div>
        <p class="lib__text-center ">
          <span class="lib__h2 lib__btn--full">{{ $t('vatInfo.vatRateLess10Years') }}</span>
        </p>
        <!-- <p class="lib__text-center">{{ $t('vatInfo.vatRateSixPercentDescription') }}</p> -->
      </div>
      <div v-else-if="showNeedExemptionFormMessage">
        <div class="lib__text-center">
          <i class="lib__icon__check__circle--success lib__icon__check__circle--big fas fa-exclamation-circle"></i>
        </div>
        <p class="lib__text-center ">
          <span class="lib__h2 lib__btn--full">{{ $t('vatInfo.needExemptionFormMessage') }}</span>
        </p>
        <p class="lib__text-center">{{ $t('vatInfo.needExemptionFormMessageDescription') }}</p>
      </div>
      <div v-else-if="showBasicMessage">
        <div class="lib__text-center">
          <i class="lib__icon__check__circle--success lib__icon__check__circle--big fas fa-check-circle"></i>
        </div>
        <p class="lib__text-center ">
          <span class="lib__h2 lib__btn--full">{{ $t('vatInfo.basicMessage') }}</span>
        </p>
        <p class="lib__text-center">{{ $t('vatInfo.basicMessageDescription') }}</p>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IndividualVatInfoSelection, CompanyVatInfoSelection, FreelanceVatInfoSelection } from '@/models'

@Component({
  name: 'vat-info-box'
})
export default class VatInfoBox extends Vue {
  //#region [Property]
  @Prop({ type: String, required: true }) public readonly type!: string
  @Prop({ type: Boolean, default: false }) public readonly required!: boolean
  @Prop({
    type: Number,
    required: false,
    default: null,
    validator: (v: IndividualVatInfoSelection | null) => {
      return v == null || +v in IndividualVatInfoSelection
    }
  })
  public readonly individual!: IndividualVatInfoSelection | null
  @Prop({
    type: Number,
    required: false,
    default: null,
    validator: (v: FreelanceVatInfoSelection | null) => v == null || +v in FreelanceVatInfoSelection
  })
  public readonly freelance!: FreelanceVatInfoSelection | null
  @Prop({
    type: Object,
    required: false,
    default: null
  })
  public readonly company!: CompanyVatInfoSelection | null
  //#endregion

  //#region [Computed]
  get showVatSixPercentMessage() {
    if (this.type === 'individual') {
      return this.individual === 1
    } else if (this.type === 'freelance') {
      return false
    } else if (this.type === 'company') {
      if (this.company && this.company.primaryInfo && this.company.secondaryInfo === null) {
        return this.company.primaryInfo === 5 || this.company.primaryInfo === 7
      } else if (this.company && this.company.secondaryInfo) {
        return this.company.secondaryInfo === 5
      }
    }
    return false
  }

  get showVatLess10YearsMessage() {
    if (this.type === 'individual') {
      return this.individual === 0
    }
    return false
  }

  get showBasicMessage() {
    if (this.type === 'freelance') {
      return this.freelance !== null
    } else if (this.type === 'company') {
      if (this.company != null && this.company.primaryInfo != null && this.company.secondaryInfo === null) {
        return this.company.primaryInfo === 6
      } else if (this.company != null && this.company.secondaryInfo != null) {
        return (
          this.company.secondaryInfo === 0 ||
          this.company.secondaryInfo === 1 ||
          this.company.secondaryInfo === 2 ||
          this.company.secondaryInfo === 3 ||
          this.company.secondaryInfo === 4
        )
      }
    }
    return false
  }

  get showNeedExemptionFormMessage() {
    if (this.type === 'individual') {
      return false
    } else if (this.type === 'freelance') {
      return false
    } else if (this.type === 'company') {
      if (this.company && this.company.primaryInfo && this.company.secondaryInfo === null) {
        return this.company.primaryInfo === 3
      }
    }
    return false
  }

  //#endregion
}
</script>

<style scoped>
/* TODO : Remettre ceci dans la librairie afin de gérer le cas avec uniquement un titre */
@media screen and (min-width: 992px) {
  .lib__feedback__content h3:only-child {
    padding-top: 15px;
  }
}

@media (max-width: 992px) and (min-width: 576px) {
  .lib__feedback__content h3:only-child {
    padding-top: 10px;
  }
}
</style>
